@if (isTruncated) {
    <div class="truncated-text-content" 
        [innerHTML]="text" 
        #textRef  
        [style.maxHeight.px]="(isTruncated && isShown ) ? (initialHeight + 30) : truncateHeight">
    </div>


    <div class="truncate-overlay" [class.isShown]="isShown" (click)="toggleText()">
        @if (isShown) {
            <p-button class="truncated-text-button truncated-text-button-hide" icon outlined rounded size="small">
                <span class="material-symbols-outlined">
                    keyboard_arrow_up
                </span>
            </p-button>
        }
        @else {
            <p-button class="truncated-text-button truncated-text-button-show" icon outlined rounded size="small">
                <span class="material-symbols-outlined">
                    keyboard_arrow_down
                </span>
            </p-button>
        }
        
    </div>
}

@else {
    <div class="truncated-text-content" 
        [innerHTML]="text" 
        #textRef  
        >
    </div>
}

